(function() {
  var page = document.querySelector('[data-ghost-cart-page]');
  if (!page) return;

  var errorNode = page.querySelector('[data-ghost-cart-page-error]');
  var errorText = page.getAttribute('data-error-text') || 'Could not update your cart. Please try again.';
  var cartChangeUrl = page.getAttribute('data-cart-change-url') || '/cart/change.js';

  function showError(message) {
    if (!errorNode) return;
    errorNode.textContent = message;
    errorNode.hidden = false;
  }

  function hideError() {
    if (!errorNode) return;
    errorNode.hidden = true;
    errorNode.textContent = '';
  }

  function parseJsonResponse(response) {
    return response.text().then(function(text) {
      var trimmed = (text || '').trim();

      if (!trimmed) {
        throw new Error(errorText);
      }

      if (trimmed.charAt(0) === '<') {
        throw new Error(errorText);
      }

      try {
        return JSON.parse(trimmed);
      } catch (parseError) {
        throw new Error(errorText);
      }
    });
  }

  function changeLineItem(key, quantity, itemNode) {
    if (itemNode) itemNode.classList.add('is-updating');
    hideError();

    return fetch(cartChangeUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
      .then(function(response) {
        if (!response.ok) {
          return parseJsonResponse(response).catch(function() {
            throw new Error(errorText);
          }).then(function(payload) {
            throw new Error((payload && payload.description) || errorText);
          });
        }
        return parseJsonResponse(response);
      })
      .then(function() {
        window.location.reload();
      })
      .catch(function(error) {
        if (itemNode) itemNode.classList.remove('is-updating');
        showError(error.message || errorText);
      });
  }

  page.addEventListener('click', function(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var itemNode = target.closest('[data-cart-item-key]');
    if (!itemNode) return;

    var key = itemNode.getAttribute('data-cart-item-key');
    if (!key) return;

    var qtyNode = itemNode.querySelector('[data-cart-page-qty-value]');
    var currentQty = qtyNode ? Number(qtyNode.textContent || '0') : 0;

    if (target.closest('[data-cart-page-qty-decrease]')) {
      event.preventDefault();
      changeLineItem(key, Math.max(0, currentQty - 1), itemNode);
      return;
    }

    if (target.closest('[data-cart-page-qty-increase]')) {
      event.preventDefault();
      changeLineItem(key, currentQty + 1, itemNode);
      return;
    }

    if (target.closest('.ghost-cart-page__remove')) {
      event.preventDefault();
      changeLineItem(key, 0, itemNode);
    }
  });
})();
